"use strict";

exports.__esModule = true;
exports.StyledPre = exports.StyledCode = void 0;

var _stitches = require("../theme/stitches.config");

const StyledCode = (0, _stitches.styled)('code', {});
exports.StyledCode = StyledCode;
const StyledPre = (0, _stitches.styled)('pre', {
  width: 'initial',
  mw: '100'
});
exports.StyledPre = StyledPre;